import React from "react";
import PropTypes from "prop-types";
import { Grid, Box, Button, SvgIcon, Tooltip, Link } from "@material-ui/core";
import { useDropzone } from "react-dropzone";
import { makeStyles } from "@material-ui/core/styles";
import T from "i18n-react";
import AddIcon from "@material-ui/icons/Add";
import { getFileNameDisplay, openFileURL } from "util/fileUtil";

const useStyles = makeStyles(theme => ({
    uploadButton: {
        marginTop: "10px",
        padding: "10px",
        background: "#E5ECF6",
        borderRadius: "2px",
    },
    svgIcon: {
        color: "#2154A2",
    }
}));

const UploadFiles = ({ title, files, setFiles }) => {
    const classes = useStyles();
    const { getRootProps, getInputProps } = useDropzone({
        onDrop: acceptedFiles => {
            setFiles(
                acceptedFiles.map(file =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                )
            );
        },
    });

    const renderFileLinks = (file, index) => (
        <Tooltip key={`${file.name}_${index}`} title={file.name}>
            <Link
                component="button"
                underline="always"
                onClick={() => openFileURL(file.url)}
            >
                {getFileNameDisplay(file.name)}
            </Link>
        </Tooltip>
    );

    return (
        <Box py={2}>
            <Grid item xs={12}>
                <Box fontSize="12px" fontWeight="400">
                    {title}
                </Box>
                <Box {...getRootProps()}>
                    <input {...getInputProps()} />
                    <Button classes={{ root: classes.uploadButton }}>
                        <SvgIcon classes={{ root: classes.svgIcon }} fontSize="small">
                            <AddIcon />
                        </SvgIcon>
                        <Box color="#2154A2" fontSize="14px" fontWeight="500">
                            {T.translate("productManager.upload")}
                        </Box>
                    </Button>
                </Box>
            </Grid>
            <Grid container>
                <Box
                    marginTop="10px"
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start">
                    {files.map((file, index) => renderFileLinks(file, index))}
                </Box>
            </Grid>
        </Box>
    );
};

UploadFiles.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    files: PropTypes.array.isRequired,
    setFiles: PropTypes.func.isRequired
};

export default UploadFiles;
